import React, { useState, useEffect } from "react";
import axios from "axios";
import { NODE_HOST_URL, NODE_HOST_URL_v1 } from "../../api/Api";
import styles from './urlShortenerModal.module.css'

const UrlShortenerModal = ({ onClose, onUrlSelect }) => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  const [urlList, setUrlList] = useState([]);

  useEffect(() => {
    fetchUrlList();
  }, [userId, userToken]);

  const fetchUrlList = async () => {
    if (!userId || !userToken) return;
    const payload = {
      user_id: userId,
      method: "retrieve",
    };

    try {
      const { data } = await axios.post(`${NODE_HOST_URL_v1}/urlList`, payload, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      if (data.success) {
        setUrlList(data.data);
      }
    } catch (error) {
      console.error("Error fetching URL list", error);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* Close Button */}
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>

        <h4 className="text-center">URL Shortener List</h4>

        {/* Scrollable Table Container */}
        <div className={styles.tableContainer}>
          <table className="table table-bordered table-striped">
            <thead className="thead-dark">
              <tr>
                <th>Channel</th>
                <th>Short URL</th>
                <th>Main URL</th>
                <th>Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {urlList.length > 0 ? (
                urlList.map((item) => (
                  <tr key={item._id}>
                    <td>{item.channel}</td>
                    <td>
                      <button
                        className="btn btn-link"
                        onClick={() => {
                          onUrlSelect(item);
                          // onClose(); // Close modal after selecting
                        }}
                      >
                        {item.url}
                      </button>
                    </td>
                    <td>
                      <a href={item.main_url} target="_blank" rel="noopener noreferrer">
                        {item.main_url}
                      </a>
                    </td>
                    <td style={{ color: item.status === 1 ? "green" : "red" }}>
                      {item.status === 1 ? "Active" : "Inactive"}
                    </td>
                    <td>{new Date(item.created_date).toLocaleString()}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UrlShortenerModal;
